import React from 'react';

import {Heading, ListGroupItem} from '@albert-io/atomic';

export default function EmptyQuestionShell() {
  return (
    <div className='rounded-x1 border border-solid border-border-primary background-primary'>
      <ListGroupItem>
        <Heading as='h1' size='xs' className='m-x0'>
          <span>&nbsp;</span>
        </Heading>
      </ListGroupItem>
      <div className='min-h-[400px] p-x4' />
    </div>
  );
}
